import { useState } from 'react';
import { Field, FieldProps } from 'formik';
import { validateState } from "./validate";
import classnames from 'classnames';
import { statesData } from 'data/state';

export function StateInput() {
    const [showError, setShowError] = useState(false);

    const openShowError = () => {
        if (!showError) {
            setShowError(true);
        }
    }

    return (
        <Field name="state" validate={validateState}>
            {(props: FieldProps) => {
                const { field: { name, value, onChange, onBlur }, form: { isSubmitting, values }, meta: { error } } = props;

                if (isSubmitting) {
                    openShowError();
                }

                const country: string = values.country ?? "";
                const states: any[] = statesData[country] ?? [];

                return (
                    <div>
                        <label
                            htmlFor="state"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                            State *
                        </label>
                        {states.length > 0 ? (
                            <select
                                className={
                                    classnames(
                                        "no-icon-select select_icon bg-gray-50 border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full ps-2.5 pe-10 py-2.5",
                                        {
                                            "border-gray-300 focus:border-blue-500 focus:ring-blue-500": !(showError && error),
                                            "border-red-500 focus:border-red-500 focus:ring-red-500": showError && error,
                                        },
                                    )
                                }
                                name={name}
                                value={value ?? ""}
                                onChange={onChange}
                                onBlur={onBlur}
                                onFocus={openShowError}
                            >

                                <option disabled value="">
                                    Select state
                                </option>

                                {states.map((state: any, index: number) => (
                                    <option key={index} value={state.key}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input
                                className={
                                    classnames(
                                        "bg-gray-50 border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full p-2.5",
                                        {
                                            "border-gray-300 focus:border-blue-500 focus:ring-blue-500": !(showError && error),
                                            "border-red-500 focus:border-red-500 focus:ring-red-500": showError && error,
                                        },
                                    )
                                }
                                name={name}
                                value={value ?? ""}
                                onChange={onChange}
                                onBlur={onBlur}
                                onFocus={openShowError}
                            />
                        )}

                        {showError && error && (
                            <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
                        )}
                    </div>
                );
            }}
        </Field>
    );
}